import _extends from "@babel/runtime/helpers/extends";

/**
 * @module ViewControls
 */
import React from 'react';
import { EditView } from "./edit-view.js";
/**
 * Interface for NewView properties
 */

/**
 * View Control for adding a Content, works with a single Content and based on the ReactControlMapper
 *
 * Usage:
 * ```html
 *  <NewView contentTypeName={'Folder'} repository={repository} onSubmit={createSubmitClick} />
 * ```
 */
export const NewView = props => {
  const actionName = props.actionName || 'new';
  return /*#__PURE__*/React.createElement(EditView, _extends({}, props, {
    actionName: actionName
  }));
};
//# sourceMappingURL=new-view.js.map